"use client"

import { useState } from "react"
import logo from "../img/logo.png"
import "./css/hamburguesa.css"

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  const closeMenu = () => {
    setIsMenuOpen(false)
  }

  const handleContactClick = (e) => {
    e.preventDefault()
    const phoneNumber = "50256976272"
    const message = "Hola, me interesa obtener más información sobre sus servicios aduaneros."
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`

    window.open(whatsappUrl, "_blank")
    closeMenu()
  }

  return (
    <nav className="navbar navbar-expand-lg header-top">
      <div className="container-fluid">
        <a className="navbar-brand" href="#Inicio">
          <div className="logo-container">
            <img className="img-logo" src={logo || "/placeholder.svg"} alt="logo amt" width="150" height="100" />
            <div className="company-name">AMT CUSTOMS SERVICES</div>
          </div>
        </a>

        {/* Botón hamburguesa personalizado */}
        <button
          className={`hamburger-menu ${isMenuOpen ? "active" : ""}`}
          type="button"
          onClick={toggleMenu}
          aria-label="Toggle navigation"
        >
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
        </button>

        <div
          className={`collapse navbar-collapse navbar-collapse-header ${isMenuOpen ? "show-mobile-menu" : ""}`}
          id="navbarTogglerHeader"
        >
          <div className="d-flex nav-links-container">
            <ul className="navbar-nav mx-auto mb-2 mb-lg-0 nav-underline">
              <li className="nav-item">
                <a className="nav-link a-header" aria-current="page" href="#Inicio" onClick={closeMenu}>
                  Inicio
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link a-header" href="#Somos2" onClick={closeMenu}>
                  Cauca y Recauca
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link a-header" href="#Somos" onClick={closeMenu}>
                  Acerca de AMT
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link a-header a-header-contactanos" href="#" onClick={handleContactClick}>
                  Contáctanos
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  )
}

export default Header
